module.exports = __webpack_public_path__ + "img/old_portfolio_icon.e5221d2d.png";